import { Check, Mail } from 'lucide-react';
import { type ReactNode } from 'react';

import {
    SelectionBar,
    SelectionBarAction,
} from '@apps/web/components/ui/selection_bar';

type ConversationInboxBulkBarProps = {
    readonly selectedCount: number;
    readonly isPending: boolean;
    readonly onClearSelection: () => void;
    readonly onMarkAsRead: () => void;
    readonly onMarkAsUnread: () => void;
    readonly assignControl: ReactNode;
};

export function ConversationInboxBulkBar({
    selectedCount,
    isPending,
    onClearSelection,
    onMarkAsRead,
    onMarkAsUnread,
    assignControl,
}: ConversationInboxBulkBarProps) {
    return (
        <SelectionBar
            aria-label="Selected conversations"
            selectedCount={selectedCount}
            onClearSelection={onClearSelection}
            className="absolute bottom-16 left-1/2 z-10"
            data-testid="conversations-inbox-bulk-bar"
        >
            <SelectionBarAction
                label="Mark as read"
                data-testid="conversations-inbox-bulk-read"
                disabled={isPending}
                onClick={onMarkAsRead}
            >
                <Check className="size-4" />
            </SelectionBarAction>
            <SelectionBarAction
                label="Mark as unread"
                data-testid="conversations-inbox-bulk-unread"
                disabled={isPending}
                onClick={onMarkAsUnread}
            >
                {/* Match the row's unread dot: an open envelope implies read. */}
                <span className="relative inline-flex">
                    <Mail className="size-4" />
                    <span
                        aria-hidden={true}
                        data-testid="conversations-inbox-bulk-unread-dot"
                        className="absolute -top-0.5 -right-0.5 size-1.5 rounded-full bg-blue-500 ring-1 ring-zinc-900"
                    />
                </span>
            </SelectionBarAction>
            <div
                className={
                    isPending ? 'pointer-events-none opacity-50' : undefined
                }
            >
                {assignControl}
            </div>
        </SelectionBar>
    );
}
